import React, { ReactElement } from "react";
import MainLayout from "components/Layout/MainLayout";
import { useLang } from "hooks/useLang";

interface IProps {
  showSearch?: boolean;
  supportText?: string;
  Title?: string;
  //title padding
  TitlePa?: string;
  imgUrl?: string;
  children?: ReactElement;
  centerTitle?: boolean;
  forceDirectionLtr?: boolean;
}

export default function SupportLayout({
  // showSearch = true,
  supportText,
  // imgUrl,
  Title,
  TitlePa,
  centerTitle,
  children,
  forceDirectionLtr,
}: IProps) {
  // const linearBg = imgUrl ? "" : "" //"linear-bg"
  TitlePa = centerTitle ? "" : TitlePa ? TitlePa : "pt-24";
  // const centering = centerTitle ? " flex justify-center items-center " : ""

  const { isAr, t } = useLang();

  return (
    <>
      <MainLayout>
        <div dir={forceDirectionLtr ? "ltr" : isAr ? "rtl" : "ltr"}>
          <div className="support-layout">
            <p
              className={
                TitlePa +
                " text-[2.1rem] font-black dark:text-white sm:text-[2.5rem] md:text-5xl "
              }
            >
              {Title ? Title : t("HELP_AND_SUPPORT")}
            </p>

            {supportText && (
              <p className="mt-12 text-[1.3rem] font-medium dark:text-white md:text-2xl md:text-[19px]">
                {supportText}
              </p>
            )}
            {/* {showSearch && (
                            <SearchBar
                                className={
                                    supportText ? "mt-12" : "mt-[9.375rem]"
                                }
                            />
                            )} */}
          </div>
        </div>

        {children}
      </MainLayout>
    </>
  );
}
